
import { LayoutCrearDoc } from "../../layouts";
import { useListOpTodas } from "../../../hooks/cache";
import { TablaDeOps } from "../components";
import { BusquedaFechaTermino } from "../../components/buscadores";
import { CargandoMedio } from "../../components";





export const TodasOps = () => {


    const { data, isLoading, chagePage, page, termino, chageTermino, inicio, final, chageInicio, chageFinal } = useListOpTodas();


    return (

        
        <LayoutCrearDoc titulo='Listado Ops' add={false}>
            {(isLoading)
            ?   <CargandoMedio titulo="Cargando información de ops..." />
            :   <>
                <BusquedaFechaTermino
                    termino={termino} chageTermino={chageTermino} 
                    inicio={inicio} chageInicio={chageInicio}
                    final={final} chageFinal={chageFinal} 
                    titulo='Buscar op' place='Buscar x op estado movil usuario pago...'
                />
                <TablaDeOps data={data || []} chagePage={chagePage} page={page} />
                </>
            }
        </LayoutCrearDoc>
    )
}
